import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-paper">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
        <div className="grid md:grid-cols-12 gap-12 md:gap-8">
          <div className="md:col-span-6">
            <p className="font-serif text-3xl md:text-5xl tracking-tight leading-[1.05] max-w-md">
              No one should have to grow alone, go alone or{" "}
              <span className="italic text-clay">grapple alone.</span>
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.28em] text-paper/50 mb-6">
              Explore
            </p>
            <ul className="space-y-4">
              <li>
                <Link
                  to="/"
                  data-testid="footer-link-home"
                  className="text-paper/80 hover:text-paper transition-colors duration-300"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  data-testid="footer-link-about"
                  className="text-paper/80 hover:text-paper transition-colors duration-300"
                >
                  About Alex
                </Link>
              </li>
              <li>
                <Link
                  to="/messy-middle"
                  data-testid="footer-link-messy-middle"
                  className="text-paper/80 hover:text-paper transition-colors duration-300"
                >
                  The Messy Middle
                </Link>
              </li>
              <li>
                <Link
                  to="/work-with-alex"
                  data-testid="footer-link-work-with-alex"
                  className="text-paper/80 hover:text-paper transition-colors duration-300"
                >
                  Work With Alex
                </Link>
              </li>
              <li>
                <Link
                  to="/organisations"
                  data-testid="footer-link-organisations"
                  className="text-paper/80 hover:text-paper transition-colors duration-300"
                >
                  For Organisations
                </Link>
              </li>
              <li>
                <Link
                  to="/resources"
                  data-testid="footer-link-resources"
                  className="text-paper/80 hover:text-paper transition-colors duration-300"
                >
                  Resources
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  data-testid="footer-link-contact"
                  className="text-paper/80 hover:text-paper transition-colors duration-300"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="text-xs uppercase tracking-[0.28em] text-paper/50 mb-6">
              Begin
            </p>
            <p className="text-paper/80 leading-relaxed mb-6">
              Tell me where you are. Let's explore what's possible from here.
            </p>
            <Link
              to="/work-with-alex"
              data-testid="footer-cta-work-with-alex"
              className="inline-block border border-paper/30 text-xs uppercase tracking-[0.2em] px-6 py-3 hover:bg-paper hover:text-ink transition-colors duration-300"
            >
              Work With Alex
            </Link>
          </div>
        </div>
        <div className="mt-20 pt-8 border-t border-paper/15 flex flex-col md:flex-row justify-between gap-4 text-xs text-paper/40 tracking-wide">
          <p>People Growing People — coaching, leadership & people growth.</p>
          <p>Becoming is more important than arrival.</p>
        </div>
      </div>
    </footer>
  );
}
